import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { tariffTableCustomStyles, tariffChargeTableCustomStyles } from "../../utils/TableCustomStyles";

function ManageTariff() {
  const addform = useRef(null);
  const searchform = useRef(null);
  const addchargeform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [chargeList, setChargeList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [poaTerminalList, setPoaTerminalList] = useState([]);
  const [polTerminalList, setPolTerminalList] = useState([]);
  const [podTerminalList, setPodTerminalList] = useState([]);
  const [fdTerminalList, setFdTerminalList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage['userrole']  
  const user_id = sessionStorage['id']
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);
  const [showSearchForm, setShowSearchForm] = useState(false);


  // ------------------------------------ ADD --------------------------------------------
  const [showCurrentAgentError, setShowCurrentAgentError] = useState(false);
  const [showCurrentPoaError, setShowCurrentPoaError] = useState(false);
  const [showCurrentPoaTerminalError, setShowCurrentPoaTerminalError] = useState(false);
  const [showCurrentEventTypeError, setShowCurrentEventTypeError] = useState(false);
  const [showCurrentEventSubTypeError, setShowCurrentEventSubTypeError] = useState(false);
  const [showCurrentCurrencyError, setShowCurrentCurrencyError] = useState(false);
  const [showCurrentCargoTypeError, setShowCurrentCargoTypeError] = useState(false);

  const [currentAgent, setCurrentAgent] = useState("");
  const [currentPoa, setCurrentPoa] = useState("");
  const [currentPoaTerminal, setCurrentPoaTerminal] = useState("");
  const [currentPol, setCurrentPol] = useState("");
  const [currentPolTerminal, setCurrentPolTerminal] = useState("");
  const [currentPod, setCurrentPod] = useState("");
  const [currentPodTerminal, setCurrentPodTerminal] = useState("");
  const [currentFd, setCurrentFd] = useState("");
  const [currentFdTerminal, setCurrentFdTerminal] = useState("");
  const [currentVendor, setCurrentVendor] = useState("");
  const [currentEventType, setCurrentEventType] = useState("");
  const [currentEventSubType, setCurrentEventSubType] = useState("");
  const [currentAddAfterEvent, setCurrentAddAfterEvent] = useState("");
  const [currentCurrency, setCurrentCurrency] = useState("");
  const [currentCargoType, setCurrentCargoType] = useState("");
  const [currentContainerMinWeight, setCurrentContainerMinWeight] = useState(0.0);
  const [currentContainerMaxWeight, setCurrentContainerMaxWeight] = useState(0.0);
  const [currentBillOfLandingCharge, setCurrentBillOfLandingCharge] = useState(0.0);
  const [currentHd20, setCurrentHd20] = useState(0.0);
  const [currentHd40, setCurrentHd40] = useState(0.0);
  const [currentHq40, setCurrentHq40] = useState(0.0);
  const [currentCommodity, setCurrentCommodity] = useState("");
  const [currentFreight, setCurrentFreight] = useState("");
  const [currentIhc, setCurrentIhc] = useState("");
  const [currentDeliveryType, setCurrentDeliveryType] = useState("");

  // ------------------------------------ UPDATE --------------------------------------------
  const [showUpdateAgentError, setShowUpdateAgentError] = useState(false);
  const [showUpdatePoaError, setShowUpdatePoaError] = useState(false);
  const [showUpdatePoaTerminalError, setShowUpdatePoaTerminalError] = useState(false);
  const [showUpdateEventTypeError, setShowUpdateEventTypeError] = useState(false);
  const [showUpdateEventSubTypeError, setShowUpdateEventSubTypeError] = useState(false);
  const [showUpdateCurrencyError, setShowUpdateCurrencyError] = useState(false);
  const [showUpdateCargoTypeError, setShowUpdateCargoTypeError] = useState(false);

  const [updateId, setUpdateId] = useState("");
  const [updateAgent, setUpdateAgent] = useState("");
  const [updatePoa, setUpdatePoa] = useState("");
  const [updatePoaTerminal, setUpdatePoaTerminal] = useState("");
  const [updatePol, setUpdatePol] = useState("");
  const [updatePolTerminal, setUpdatePolTerminal] = useState("");
  const [updatePod, setUpdatePod] = useState("");
  const [updatePodTerminal, setUpdatePodTerminal] = useState("");
  const [updateFd, setUpdateFd] = useState("");
  const [updateFdTerminal, setUpdateFdTerminal] = useState("");
  const [updateVendor, setUpdateVendor] = useState("");
  const [updateEventType, setUpdateEventType] = useState("");
  const [updateEventSubType, setUpdateEventSubType] = useState("");
  const [updateAddAfterEvent, setUpdateAddAfterEvent] = useState("");
  const [updateCurrency, setUpdateCurrency] = useState("");
  const [updateCargoType, setUpdateCargoType] = useState("");
  const [updateContainerMinWeight, setUpdateContainerMinWeight] = useState(0.0);
  const [updateContainerMaxWeight, setUpdateContainerMaxWeight] = useState(0.0);
  const [updateBillOfLandingCharge, setUpdateBillOfLandingCharge] = useState(0.0);
  const [updateHd20, setUpdateHd20] = useState(0.0);
  const [updateHd40, setUpdateHd40] = useState(0.0);
  const [updateHq40, setUpdateHq40] = useState(0.0);
  const [updateCommodity, setUpdateCommodity] = useState("");
  const [updateFreight, setUpdateFreight] = useState("");
  const [updateIhc, setUpdateIhc] = useState("");
  const [updateDeliveryType, setUpdateDeliveryType] = useState("");

  const [showTariffDetails, setShowTariffDetails] = useState(true);
  const [showTariffCharges, setShowTariffCharges] = useState(false);
  const [tariffChargeList, setTariffChargeList] = useState([]);
  const [chargeDataPending, setChargeDataPending] = useState(false);
  

  // ------------------------------------ ADD Tariff Charges --------------------------------------------
  const [port, setPort] = useState("");
  const [chargeName, setChargeName] = useState("");
  const [product, setProduct] = useState("");
  const [chargeType, setChargeType] = useState("");
  const [chargeCategory, setChargeCategory] = useState("");
  const [chargeBasis, setChargeBasis] = useState("");
  const [amount, setAmount] = useState("");
  const [amountType, setAmountType] = useState("");
  const [expense, setExpense] = useState("");
  const [chargeCurrency, setChargeCurrency] = useState("");
  const [isMandatory, setIsMandatory] = useState(true);
  const [isTerminalSpecificCharge, setIsTerminalSpecificCharge] = useState(false);
  const [terminal, setTerminal] = useState("");
  const [payableBy, setPayableBy] = useState("SHIPPER");
  const [chargeValidFrom, setChargeValidFrom] = useState("");
  const [chargeValidTo, setChargeValidTo] = useState("");
  const [chargeRemarks, setChargeRemarks] = useState("");
  const [chargeIsActive, setChargeIsActive] = useState(true);
  const [productList, setProductList] = useState([]);
  const [terminalList, setTerminalList] = useState([]);
  const [showAddChargeLoader, setShowAddChargeLoader] = useState(false);
  

  const [showPortError, setShowPortError] = useState(false);
  const [showChargeNameError, setShowChargeNameError] = useState(false);
  const [showProductError, setShowProductError] = useState(false);
  const [showChargeTypeError, setShowChargeTypeError] = useState(false);
  const [showChargeCategoryError, setShowChargeCategoryError] = useState(false);
  const [showChargeBasisError, setShowChargeBasisError] = useState(false);
  const [showAmountError, setShowAmountError] = useState(false);
  const [showAmountTypeError, setShowAmountTypeError] = useState(false);
  const [showExpenseError, setShowExpenseError] = useState(false);
  const [showChargeCurrencyError, setShowChargeCurrencyError] = useState(false);
  const [showTerminalError, setShowTerminalError] = useState(false);
  const [showValidFromError, setShowValidFromError] = useState(false);
  const [showValidToError, setShowValidToError] = useState(false);


  // ------------------------------------ Update Tariff Charges --------------------------------------------
  const [tariffChargeForUpdate, setTariffChargeForUpdate] = useState(false);
  const [showChargeDeleteModal, setShowChargeDeleteModal] = useState("");
  const [chargeRecordForDelete, setChargeRecordForDelete] = useState("");
  const [updateChargePort, setUpdateChargePort] = useState("");
  const [updateChargeTariff, setUpdateChargeTariff] = useState("");
  const [updateChargeProduct, setUpdateChargeProduct] = useState("");
  const [updateChargeType, setUpdateChargeType] = useState("");
  const [updateChargeName, setUpdateChargeName] = useState("");
  const [updateChargeCategory, setUpdateChargeCategory] = useState("");
  const [updateChargeBasis, setUpdateChargeBasis] = useState("");
  const [updateChargeCurrency, setUpdateChargeCurrency] = useState("");
  const [updateChargeAmount, setUpdateChargeAmount] = useState(0);
  const [updateChargeAmountType, setUpdateChargeAmountType] = useState("");
  const [updateChargeExpense, setUpdateChargeExpense] = useState(0);
  const [updateIsTerminalSpecificCharge, setUpdateIsTerminalSpecificCharge] = useState(false);
  const [updateChargeTerminal, setUpdateChargeTerminal] = useState("");
  const [updateIsMandatoryCharge, setUpdateIsMandatoryCharge] = useState(false);
  const [updateChargePayableBy, setUpdateChargePayableBy] = useState("");
  const [updateChargeValidFrom, setUpdateChargeValidFrom] = useState("");
  const [updateChargeValidTo, setUpdateChargeValidTo] = useState("");
  const [updateChargeRemarks, setUpdateChargeRemarks] = useState("");
  const [updateChargeIsActive, setUpdateChargeIsActive] = useState("");

  const [showUpdatePortError, setShowUpdatePortError] = useState(false);
  const [showUpdateChargeNameError, setShowUpdateChargeNameError] = useState(false);
  const [showUpdateProductError, setShowUpdateProductError] = useState(false);
  const [showUpdateChargeTypeError, setShowUpdateChargeTypeError] = useState(false);
  const [showUpdateChargeCategoryError, setShowUpdateChargeCategoryError] = useState(false);
  const [showUpdateChargeBasisError, setShowUpdateChargeBasisError] = useState(false);
  const [showUpdateAmountError, setShowUpdateAmountError] = useState(false);
  const [showUpdateAmountTypeError, setShowUpdateAmountTypeError] = useState(false);
  const [showUpdateExpenseError, setShowUpdateExpenseError] = useState(false);
  const [showUpdateChargeCurrencyError, setShowUpdateChargeCurrencyError] = useState(false);
  const [showUpdateTerminalError, setShowUpdateTerminalError] = useState(false);
  const [showUpdateValidFromError, setShowUpdateValidFromError] = useState(false);
  const [showUpdateValidToError, setShowUpdateValidToError] = useState(false);

  const getLoggenInUser = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/'+user_id);
        if (response) {
            setLoggedInUser(response.data)
        }
    } catch (err) {
        toast.error("Error in fetching user data! Try again.");
    }
  }
  
  const getTariff = async () => {
    try {
        setDataPending(true)
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/tariff/');
        if (response) {
            setData(response.data)
            setDataPending(false)
        }       
    } catch (err) {
        toast.error("Error in fetching customer data! Try again.");
    }
  }

  const getAgent = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/agent/');
        const agent_data = response.data
        const sorted_data = agent_data.sort((a, b) => a.name - b.name)
        setAgentList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching agent data! Try again.");
    }
  }

  const getPort = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/port/');
        const port_data = response.data
        const sorted_data = port_data.sort((a, b) => a.name - b.name)
        setPortList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching port data! Try again.");
    }
  }

  const getPoaTerminal = async (port, type) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/terminal?port='+port);
        const terminal_data = response.data
        const sorted_data = terminal_data.sort((a, b) => a.name - b.name)
        setPoaTerminalList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching terminal data! Try again.");
    }
  }

  const getPolTerminal = async (port) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/terminal?port='+port);
        const terminal_data = response.data
        const sorted_data = terminal_data.sort((a, b) => a.name - b.name)
        setPolTerminalList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching terminal data! Try again.");
    }
  }

  const getPodTerminal = async (port) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/terminal?port='+port);
        const terminal_data = response.data
        const sorted_data = terminal_data.sort((a, b) => a.name - b.name)
        setPodTerminalList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching terminal data! Try again.");
    }
  }

  const getFdTerminal = async (port) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/terminal?port='+port);
        const terminal_data = response.data
        const sorted_data = terminal_data.sort((a, b) => a.name - b.name)
        setFdTerminalList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching terminal data! Try again.");
    }
  }

  const getVendor = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/vendor/');
        const vendor_data = response.data
        const sorted_data = vendor_data.sort((a, b) => a.name - b.name)
        setVendorList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching vendor data! Try again.");
    }
  }

  const getCurrency = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/currency/');
        const currency_data = response.data
        const sorted_data = currency_data.sort((a, b) => a.name - b.name)
        setCurrencyList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching currency data! Try again.");
    }
  }

  const getTariffCharges = async (tariff_id) => {
    try {
        setChargeDataPending(true)
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/tariffcharge?tariff='+tariff_id);
        const charge_data = response.data
        const sorted_data = charge_data.sort((a, b) => a.charge_name - b.charge_name)
        setTariffChargeList(sorted_data)
        setChargeDataPending(false)
    } catch (err) {
        toast.error("Error in fetching tariff charge data! Try again.");
    }
  }

  const getProduct = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/product/');
        const product_data = response.data
        const sorted_data = product_data.sort((a, b) => a.product_name - b.product_name)
        setProductList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching product data! Try again.");
    }
  }

  const getTerminal = async (port_id) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/terminal?port__id='+port_id);
        const terminal_data = response.data
        const sorted_data = terminal_data.sort((a, b) => a.name - b.name)
        setTerminalList(sorted_data)
    } catch (err) {
        toast.error("Error in fetching terminal data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
            
            const role_permissions_array = []
            for(let i=0; i<response.data?.length; i++){
                for(let j=0; j<response?.data[i]?.permissions_array?.length; j++){
                    if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                        role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                    }
                }
            }

            if(role_permissions_array){
                setCurrentUserRolePermissionData(role_permissions_array)
            }
              
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
      }

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false)
  }

  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true)
    setRecordForDelete(data)
  }

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id)
    setUpdateAgent(row.agent)
    setUpdatePoa(row.poa)
    getPoaTerminal(row.poa)
    setUpdatePoaTerminal(row.poa_terminal)

    setUpdatePol(row.pol)
    getPolTerminal(row.pol)
    setUpdatePolTerminal(row.pol_terminal)

    setUpdatePod(row.pod)
    getPodTerminal(row.pod)
    setUpdatePodTerminal(row.pod_terminal)

    setUpdateFd(row.fd)
    getFdTerminal(row.fd)
    setUpdateFdTerminal(row.fd_terminal)

    setUpdateVendor(row.vendor)
    setUpdateEventType(row.event_type)
    setUpdateEventSubType(row.event_sub_type)
    setUpdateAddAfterEvent(row.add_after_event)
    setUpdateCurrency(row.currency)
    setUpdateCargoType(row.cargo_type)
    setUpdateContainerMinWeight(row.container_min_weight)
    setUpdateContainerMaxWeight(row.container_max_weight)
    setUpdateBillOfLandingCharge(row.bill_of_landing_charge)
    setUpdateHd20(row.hd_20)
    setUpdateHd40(row.hd_40)
    setUpdateHq40(row.hq_40)
    setUpdateCommodity(row.commodity)
    setUpdateFreight(row.freight)
    setUpdateIhc(row.ihc)
    setUpdateDeliveryType(row.delivery_type)

    getTariffCharges(row.id)
  }

  useEffect(() => {
    getLoggenInUser()
    getTariff()
    getCurrency()
    getAgent()
    getVendor()
    getPort()
    getProduct()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const columns = [
    {
      name: 'Agent',
      selector: row => row.agent_data?.name,
      sortable: true,
    },
    {
      name: 'Shipping Route',
      width: '350px',
      selector: row => <div>
          <span><b>POA:</b> {row.poa_data?.name}</span><br></br>
          <span><b>POA Terminal:</b> {row.poa_terminal_data?.name}</span>
          <hr className="my-2"></hr>

          <span><b>POL:</b> {row.pol_data?.name}</span><br></br>
          <span><b>POL Terminal:</b> {row.pol_terminal_data?.name}</span>
          <hr className="my-2"></hr>

          <span><b>POD Terminal:</b> {row.pod_data?.name}</span><br></br>
          <span><b>POD Terminal:</b> {row.pod_terminal_data?.name}</span>
          <hr className="my-2"></hr>

          <span><b>FD:</b> {row.fd_data?.name}</span><br></br>
          <span><b>FD Terminal:</b> {row.fd_terminal_data?.name}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Cargo Type',
      width: '150px',
      selector: row => row.cargo_type,
      sortable: true,
    },
    {
      name: 'Event',
      width: '280px',
      selector: row => <div>
          <span><b>Type:</b> {row.event_type.replaceAll("_"," ")}</span><br></br>
          <span><b>Sub-Type:</b> {row.event_sub_type.replaceAll("_"," ")}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:managetariff:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection" onClick={() => handleSetUpdateData(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:managetariff:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true)
    try {
        await axios.delete(process.env.REACT_APP_BACKEND_API_URL+'/master/tariff/'+id+'/');
        setShowDeleteModal(false)
        toast.success("Record deleted successfully")
        getTariff()
    } catch (err) {
        toast.error("Error in deleting record! Try again.");
    }
    getTariff()
    setShowDeleteLoader(false)
  }

  const addNewTariff = async (e) => {
    e.preventDefault();
    setShowAddLoader(true)

    const data = {
      agent: addform.current.agent.value,
      poa: addform.current.poa.value,
      poa_terminal: addform.current.poa_terminal.value,
      pol: addform.current.pol.value,
      pol_terminal: addform.current.pol_terminal.value,
      pod: addform.current.pod.value,
      pod_terminal: addform.current.pod_terminal.value,
      fd: addform.current.fd.value,
      fd_terminal: addform.current.fd_terminal.value,
      vendor: addform.current.vendor.value,
      event_type: addform.current.event_type.value,
      event_sub_type: addform.current.event_sub_type.value,
      cargo_type: addform.current.cargo_type.value,
      // container_min_weight: addform.current.container_min_weight.value,
      // container_max_weight: addform.current.container_max_weight.value,
      // bill_of_landing_charge: addform.current.bill_of_landing_charge.value,
      // hd_20: addform.current.hd_20.value,
      // hd_40: addform.current.hd_40.value,
      // hq_40: addform.current.hq_40.value,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/tariff/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );
    if (response.status === 201 ) {
      toast.success("Tariff Created Successfully")
      addform.current.agent.value = ""
      addform.current.poa.value = ""
      addform.current.poa_terminal.value = ""
      addform.current.pol.value = ""
      addform.current.pol_terminal.value = ""
      addform.current.pod.value = ""
      addform.current.pod_terminal.value = ""
      addform.current.fd.value = ""
      addform.current.fd_terminal.value = ""
      addform.current.vendor.value = ""
      addform.current.event_type.value = ""
      addform.current.event_sub_type.value = ""
      addform.current.cargo_type.value = ""
    }
    getTariff()
    setShowAddCanvas(false)
    setShowAddLoader(false)
  }

  const updateTariff = async (e) => {
    e.preventDefault();
    setShowUpdateLoader(true)

    const id = updateId

    const data = {
      agent: updateAgent,
      poa: updatePoa,
      poa_terminal: updatePoaTerminal,
      pol: updatePol,
      pol_terminal: updatePolTerminal,
      pod: updatePod,
      pod_terminal: updatePodTerminal,
      fd: updateFd,
      fd_terminal: updateFdTerminal,
      vendor: updateVendor,
      event_type: updateEventType,
      event_sub_type: updateEventSubType,
      currency: updateCurrency,
      cargo_type: updateCargoType,
      container_min_weight: updateContainerMinWeight,
      container_max_weight: updateContainerMaxWeight,
      bill_of_landing_charge: updateBillOfLandingCharge,
      hd20: updateHd20,
      hd40: updateHd40,
      hq40: updateHq40,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL+'/master/tariff/'+id+'/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );
    if (response.status === 200 ) {
      toast.success("Tariff updated Successfully")
    }
    getTariff()
    setShowUpdateCanvas(false)
    setShowUpdateLoader(false)
  }

  const searchTariff = async (e) => {
    const charge = searchform.current.search_charge.value
    const agent = searchform.current.search_agent.value
    const cargo_type =  searchform.current.search_cargo_type.value 

    const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/master/tariff?charge__name='+charge+'&agent__name='+agent+'&cargo_type='+cargo_type);
    setData(response.data)
  }

  // -------------------------------------------- Tariff Charges --------------------------------------------------
  const tariffchargecolumns = [
    {
      name: 'Charge Details',
      selector: row => <div className="text-left">
        <span><b>Charge Name: </b>{row.charge_name}</span><br></br>
        <span><b>Product: </b>{row.product_data?.product_name}</span><br></br>
        <span><b>Charge Type: </b>{row.charge_type.replaceAll("_"," ")}</span><br></br>
        <span><b>Charge Category: </b>{row.charge_category.replaceAll("_"," ")}</span><br></br>
        <span><b>Charge Basis: </b>{row.charge_basis.replaceAll("_"," ")}</span>
      </div>,
      sortable: true,
    },
    {
      name: 'Amount and Expense',
      width: '350px',
      selector: row => <div className="text-left">
          <span><b>Amount:</b> {row.currency_data?.symbol} {row.amount}</span><br></br>
          <span><b>Amount Type:</b> {row.amount_type}</span><br></br>
          <span><b>Expense:</b> {row.currency_data?.symbol} {row.expense}</span>
        </div>,
      sortable: true,
    },
    {
      name: 'Other',
      width: '200px',
      selector: row => <div className="text-left">
          <span><b>Is Mandatory:</b> {row.is_mandatory_charge == true?"YES":"NO"}</span><br></br>
          <span><b>Is Terminal Specific:</b> {row.is_terminal_specific_charge == true?"YES":"NO"}</span><br></br>
          <span><b>Terminal:</b> {row.terminal_data?.name}</span><br></br>
        </div>,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("draftbooking:managetariff:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection" onClick={() => handleSetUpdateChargeData(row)}>
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("draftbooking:managetariff:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteChargeModalOpen(row)}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  const handleDeleteChargeModalOpen = (data) => {
    setShowChargeDeleteModal(true)
    setChargeRecordForDelete(data)
  }


  const addTariffCharge = async (e) => {
    e.preventDefault();
    setShowAddChargeLoader(true)

    const data = {
      tariff: updateId,
      port: addchargeform.current.port.value,
      charge_name: addchargeform.current.charge_name.value,
      product: addchargeform.current.product.value,
      charge_category: addchargeform.current.charge_category.value,
      charge_type: addchargeform.current.charge_type.value,
      charge_basis: addchargeform.current.charge_basis.value,
      amount: addchargeform.current.amount.value,
      amount_type: addchargeform.current.amount_type.value,
      expense: addchargeform.current.expense.value,
      currency: addchargeform.current.currency.value,
      is_mandatory_charge: addchargeform.current.is_mandatory.value == "YES"?true:false,
      is_terminal_specific_charge: addchargeform.current.is_terminal_specific.value == "YES"?true:false,
      terminal: addchargeform.current.terminal.value,
      payable_by: addchargeform.current.payable_by.value,
      valid_from: addchargeform.current.valid_from.value,
      valid_to: addchargeform.current.valid_to.value,
      remarks: addchargeform.current.remarks.value,
      is_active: addchargeform.current.is_active.value,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type})
    }

    const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/master/tariffcharge/', data,  
      {
        headers: { 'content-type': 'application/json'}
      }
    );
    if (response.status === 201 ) {
      toast.success("Tariff Charge Added Successfully")
      addchargeform.current.port.value = ""
      addchargeform.current.charge_name.value = ""
      addchargeform.current.product.value = ""
      addchargeform.current.charge_category.value = ""
      addchargeform.current.charge_type.value = ""
      addchargeform.current.charge_basis.value = ""
      addchargeform.current.amount.value = ""
      addchargeform.current.amount_type.value = ""
      addchargeform.current.expense.value = ""
      addchargeform.current.currency.value = ""
      addchargeform.current.is_mandatory.value = true
      addchargeform.current.is_terminal_specific.value = "NO"
      addchargeform.current.terminal.value = ""
      addchargeform.current.valid_from.value = ""
      addchargeform.current.valid_to.value = ""
      addchargeform.current.remarks.value = ""
      addchargeform.current.is_active.value = true
    }
    getTariffCharges(updateId)
    setShowAddChargeLoader(false)
  }

  const handleSetUpdateChargeData = (row) => {
    setTariffChargeForUpdate(true)
    setShowUpdateCanvas(true)
    setUpdateChargePort(row.port)
    setUpdateChargeTariff(row.tariff)
    setUpdateChargeProduct(row.product)
    setUpdateChargeType(row.charge_type)
    setUpdateChargeName(row.charge_name)
    setUpdateChargeCategory(row.charge_category)
    setUpdateChargeBasis(row.charge_basis)
    setUpdateChargeCurrency(row.currency)
    setUpdateChargeAmount(row.amount)
    setUpdateChargeAmountType(row.amount_type)
    setUpdateChargeExpense(row.expense)
    setUpdateIsTerminalSpecificCharge(row.is_terminal_specific_charge)
    setUpdateChargeTerminal(row.terminal)
    setUpdateIsMandatoryCharge(row.is_mandatory_charge)
    setUpdateChargePayableBy(row.payable_by)
    setUpdateChargeValidFrom(row.valid_from)
    setUpdateChargeValidTo(row.valid_to)
    setUpdateChargeRemarks(row.remarks)
    setUpdateChargeIsActive(row.is_active)
  }

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="DraftBooking" activeSubMenu="ManageTariff" activeSubMenuLevel1="Tariff" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Manage Tariff</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {
                currentUserRolePermissionData?.includes("draftbooking:managetariff:add")?
                  <Button className="btn btn-sm btn-inox-green border-0  px-3 float-right" data-bs-toggle="offcanvas" data-bs-target="#addSection">
                    <i className="fa fa-plus fa-lg text-right" style={{ paddingRight: 10 }}></i>
                    <span className="fw-bold">Add Tariff</span>
                  </Button>
                :
                  ""
              }

              {!showSearchForm?
              <Button className="btn btn-sm btn-inox-green border-0 float-right mx-2" onClick={() => setShowSearchForm(!showSearchForm)}>
                <i className="fa fa-search fa-sm text-right"></i>
              </Button>
              :""}
            </div>
          </div>
        </div>

        {showSearchForm?
        <div className="col-12 text-left" style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 20, paddingRight: 30, zIndex: 100 }}>
          <form ref={searchform} onSubmit={(e) => searchTariff(e)}>
            <div className="row">
              <div className="col-2">
                <input type="text" className="form form-control form-control-sm border-secondary" name="search_charge" placeholder="Enter Charge Name"></input>
              </div>
              <div className="col-2">
                <input type="text" className="form form-control form-control-sm border-secondary" name="search_agent" placeholder="Enter Agent Name"></input>
              </div>
              <div className="col-2">
                <select className="form form-select form-select-sm border-secondary" name="search_cargo_type">
                  <option value="">Select Cargo Type</option>
                  <option value="HAZARDOUS">HAZARDOUS</option>
                  <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                  <option value="MIX_HAZARDOUS">MIX HAZARDOUS</option>
                  <option value="EMPTY">EMPTY</option>
                </select>
              </div>
              <div className="col-2">
                <Button className="btn btn-inox-green border btn-sm px-3" onClick={(e) => searchTariff(e)}>Search</Button>
                <Button className="btn btn-secondary border btn-sm mx-1" onClick={() => setShowSearchForm(!showSearchForm)}>
                  <i className="fa fa-times"></i>
                </Button>
                <span className="px-2 pointer" 
                      style={{ verticalAlign: 'middle'}} 
                      onClick={() => [
                        searchform.current.search_charge.value = "",
                        searchform.current.search_agent.value = "",
                        searchform.current.search_cargo_type.value = "",
                        getTariff()
                      ]}>
                  Clear
                </span>
              </div>
            </div>
          </form>
        </div>
        :
        ""}

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30, zIndex: 100 }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            highlightOnHover
            fixedHeader
            customStyles={tariffTableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal size="sm" show={showDeleteModal} onHide={handleDeleteModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>Close</Button>
          <Button variant="danger" onClick={()=> deleteSelectedRecord(recordForDelete?.id)}>
            {showDeleteLoader?
            <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
            :
            "Delete"
            }
            
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div class={canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showUpdateCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        id="updateSection" data-bs-scroll="true" tabindex="-1" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Update Record</h4>
              <Button className={`${showTariffDetails ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowTariffDetails(true), setShowTariffCharges(false)]}>
                Details
              </Button>

              <Button className={`${showTariffCharges ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowTariffDetails(false), setShowTariffCharges(true)]}>
                Charges
              </Button>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowUpdateCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowUpdateCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <div style={{ display: showTariffDetails ? 'block' : 'none' }}>
            <form onSubmit={(e) => updateTariff(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="agent">Agent: <i className="text-danger">*</i><span className="text-danger">{showUpdateAgentError?"Agent required":""}</span></label>
                  <select className="form-select form-select-sm" name="agent" onChange={(e) => setUpdateAgent(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowUpdateAgentError(true):setShowUpdateAgentError(false)}>
                    <option value="" selected>Select Agent</option>
                    {agentList.map(agent => 
                      <option value={agent.id} selected={updateAgent==agent.id?true:false}>{agent.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="vendor">Vendor: </label>
                  <select className="form-select form-select-sm" name="vendor" onChange={(e) => setUpdateVendor(e.target.value)}>
                    <option value="" selected>Select Vendor</option>
                    {vendorList.map(vendor => 
                      <option value={vendor.id} selected={updateVendor==vendor.id?true:false}>{vendor.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showUpdateCurrencyError?"Currency required":""}</span></label>
                  <select className="form-select form-select-sm" name="currency" onChange={(e) => setUpdateCurrency(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowUpdateCurrencyError(true):setShowUpdateCurrencyError(false)}>
                    <option value="" selected>Select Currency</option>
                    {currencyList.map(currency => 
                      <option value={currency.id} selected={updateCurrency==currency.id?true:false}>{currency.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="poa">POA: <i className="text-danger">*</i><span className="text-danger">{showUpdatePoaError?"Poa required":""}</span></label>
                  <select className="form-select form-select-sm" name="poa" onChange={(e) => setUpdatePoa(e.target.value)}
                  onBlur={(e) => [e.target.value==""?setShowUpdatePoaError(true):setShowUpdatePoaError(false), getPoaTerminal(e.target.value)]}>
                    <option value="" selected>Select Port</option>
                    {portList.map(poa => 
                      <option value={poa.id} selected={updatePoa==poa.id?true:false}>{poa.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="poa_terminal">POA Terminal: <i className="text-danger">*</i><span className="text-danger">{showUpdatePoaTerminalError?"PoaTerminal required":""}</span></label>
                  <select className="form-select form-select-sm" name="poa_terminal" onChange={(e) => setUpdatePoaTerminal(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowUpdatePoaTerminalError(true):setShowUpdatePoaTerminalError(false)}>
                    <option value="" selected>Select Terminal</option>
                    {poaTerminalList.map(poa => 
                      <option value={poa.id} selected={updatePoaTerminal==poa.id?true:false}>{poa.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="pol">POL: </label>
                  <select className="form-select form-select-sm" name="pol" onChange={(e) => setUpdatePol(e.target.value)}
                  onBlur={(e) => getPolTerminal(e.target.value)}>
                    <option value="" selected>Select Port</option>
                    {portList.map(pol => 
                      <option value={pol.id} selected={updatePol==pol.id?true:false}>{pol.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="pol_terminal">POL Terminal: </label>
                  <select className="form-select form-select-sm" name="pol_terminal" onChange={(e) => setUpdatePolTerminal(e.target.value)}>
                    <option value="" selected>Select Terminal</option>
                    {polTerminalList.map(pol => 
                      <option value={pol.id} selected={updatePolTerminal==pol.id?true:false}>{pol.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="pod">POD: </label>
                  <select className="form-select form-select-sm" name="pod" onChange={(e) => setUpdatePod(e.target.value)}
                  onBlur={(e) => getPodTerminal(e.target.value)}>
                    <option value="" selected>Select Port</option>
                    {portList.map(pod => 
                      <option value={pod.id} selected={updatePod==pod.id?true:false}>{pod.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="pod_terminal">POD Terminal: </label>
                  <select className="form-select form-select-sm" name="pod_terminal" onChange={(e) => setUpdatePodTerminal(e.target.value)}>
                    <option value="" selected>Select Terminal</option>
                    {podTerminalList.map(pod => 
                      <option value={pod.id} selected={updatePodTerminal==pod.id?true:false}>{pod.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="fd">FD: </label>
                  <select className="form-select form-select-sm" name="fd" onChange={(e) => setUpdateFd(e.target.value)}
                  onBlur={(e) => getFdTerminal(e.target.value)}>
                    <option value="" selected>Select Port</option>
                    {portList.map(fd => 
                      <option value={fd.id} selected={updateFd==fd.id?true:false}>{fd.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="fd_terminal">FD Terminal: </label>
                  <select className="form-select form-select-sm" name="fd_terminal" onChange={(e) => setUpdateFdTerminal(e.target.value)}>
                    <option value="" selected>Select Terminal</option>
                    {fdTerminalList.map(fd => 
                      <option value={fd.id} selected={updateFdTerminal==fd.id?true:false}>{fd.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="event_type">Event Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateEventTypeError?"Event Type required":""}</span></label>
                  <select className="form-select form-select-sm" name="event_type" onChange={(e) => setUpdateEventType(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowUpdateEventTypeError(true):setShowUpdateEventTypeError(false)}>
                    <option value="" selected>Select Type</option>
                      <option value="EXPORT_PAYABLE" selected={updateEventType=="EXPORT_PAYABLE"?true:false}>EXPORT PAYABLE</option>
                      <option value="EXPORT_RECEIVABLE" selected={updateEventType=="EXPORT_RECEIVABLE"?true:false}>EXPORT RECEIVABLE</option>
                      <option value="IMPORT_PAYABLE" selected={updateEventType=="IMPORT_PAYABLE"?true:false}>IMPORT PAYABLE</option>
                      <option value="IMPORT_RECEIVABLE" selected={updateEventType=="IMPORT_RECEIVABLE"?true:false}>IMPORT RECEIVABLE</option>
                      <option value="RAIL_TO_SEA_TSP_EXPORT_PAYABLE" selected={updateEventType=="RAIL_TO_SEA_TSP_EXPORT_PAYABLE"?true:false}>RAIL TO SEA TSP EXPORT PAYABLE</option>
                      <option value="RAIL_TO_SEA_TSP_IMPORT_PAYABLE" selected={updateEventType=="RAIL_TO_SEA_TSP_IMPORT_PAYABLE"?true:false}>RAIL TO SEA TSP IMPORT PAYABLE</option>
                      <option value="SEA_TO_RAIL_TSP_EXPORT_PAYABLE" selected={updateEventType=="SEA_TO_RAIL_TSP_EXPORT_PAYABLE"?true:false}>SEA TO RAIL TSP EXPORT PAYABLE</option>
                      <option value="SEA_TO_RAIL_TSP_IMPORT_PAYABLE" selected={updateEventType=="SEA_TO_RAIL_TSP_IMPORT_PAYABLE"?true:false}>SEA TO RAIL TSP IMPORT PAYABLE</option>
                      <option value="SEA_TO_SEA_TSP_EXPORT_PAYABLE" selected={updateEventType=="SEA_TO_SEA_TSP_EXPORT_PAYABLE"?true:false}>SEA TO SEA TSP EXPORT PAYABLE</option>
                      <option value="SEA_TO_SEA_TSP_IMPORT_PAYABLE" selected={updateEventType=="SEA_TO_SEA_TSP_IMPORT_PAYABLE"?true:false}>SEA TO SEA TSP IMPORT PAYABLE</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="event_sub_type">Event Sub-Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateEventSubTypeError?"Event Sub Type required":""}</span></label>
                  <select className="form-select form-select-sm" name="event_sub_type" onChange={(e) => setUpdateEventSubType(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowUpdateEventSubTypeError(true):setShowUpdateEventSubTypeError(false)}>
                    <option value="" selected>Select Sub Type</option>
                      <option value="ALL_CONTAINERS_PICKED" selected={updateEventSubType=="ALL_CONTAINERS_PICKED"?true:false}>ALL CONTAINERS PICKED</option>
                      <option value="BL_MARKED_EXPRESS" selected={updateEventSubType=="BL_MARKED_EXPRESS"?true:false}>BL MARKED EXPRESS</option>
                      <option value="BL_MARKED_SEAWAY" selected={updateEventSubType=="BL_MARKED_SEAWAY"?true:false}>BL MARKED SEAWAY</option>
                      <option value="BL_SURRENDERED" selected={updateEventSubType=="BL_SURRENDERED"?true:false}>BL SURRENDERED</option>
                      <option value="CERTIFICATE_ISSUED" selected={updateEventSubType=="CERTIFICATE_ISSUED"?true:false}>CERTIFICATE ISSUED</option>
                      <option value="REACHED_FD" selected={updateEventSubType=="REACHED_FD"?true:false}>REACHED FD</option>
                      <option value="REACHED_TSP" selected={updateEventSubType=="REACHED_TSP"?true:false}>REACHED TSP</option>
                      <option value="SHIPPED_ON_BOARD" selected={updateEventSubType=="SHIPPED_ON_BOARD"?true:false}>SHIPPED ON BOARD</option>
                      <option value="SOB_FROM_TSP" selected={updateEventSubType=="SOB_FROM_TSP"?true:false}>SOB FROM TSP</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="cargo_type">Cargo Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateCargoTypeError?"Cargo Type required":""}</span></label>
                  <select className="form-select form-select-sm" name="cargo_type" onChange={(e) => setUpdateCargoType(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowUpdateCargoTypeError(true):setShowUpdateCargoTypeError(false)}>
                    <option value="" selected>Select Type</option>
                      <option value="HAZARDOUS" selected={updateCargoType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                      <option value="NON_HAZARDOUS" selected={updateCargoType=="NON_HAZARDOUS"?true:false}>NON_HAZARDOUS</option>
                      <option value="MIX_HAZARDOUS" selected={updateCargoType=="MIX_HAZARDOUS"?true:false}>MIX_HAZARDOUS</option>
                      <option value="EMPTY" selected={updateCargoType=="EMPTY"?true:false}>EMPTY</option>
                  </select>
                </div>
              </div>

              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-12 mt-3":"col-md-12 mt-3"}`}>
                  <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => updateTariff(e)}>
                    {showUpdateLoader?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    :
                    <>
                      <i className="fa fa-edit"></i> <span className="mx-2">Update</span>
                    </>
                    }
                    
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
          <div style={{ display: showTariffCharges ? 'block' : 'none' }}>
            <form ref={addchargeform} onSubmit={(e) => addTariffCharge(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="port">Port: <i className="text-danger">*</i><span className="text-danger">{showUpdatePortError ? " Port required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="port" onChange={(e) => [setUpdateChargePort(e.target.value), getTerminal(e.target.value)]}
                    onBlur={(e) => e.target.value == "" ? setShowUpdatePortError(true) : setShowUpdatePortError(false)}>
                    <option value="" selected>Select Port</option>
                    {portList.map(port => 
                      <option value={port.id} selected={updateChargePort==port.id?true:false}>{port.name}</option>
                    )}
                  </select>
                  </>
                  :
                  <>
                  <label for="port">Port: <i className="text-danger">*</i><span className="text-danger">{showPortError ? " Port required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="port" onChange={(e) => [setPort(e.target.value), getTerminal(e.target.value)]}
                    onBlur={(e) => e.target.value == "" ? setShowPortError(true) : setShowPortError(false)}>
                    <option value="" selected>Select Port</option>
                    {portList.map(port => 
                      <option value={port.id}>{port.name}</option>
                    )}
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="charge_name">Charge Name: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeNameError ? " Charge Name required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="charge_name" name="charge_name" placeholder="Enter Charge Name" onChange={(e) => setUpdateChargeName(e.target.value)}
                    value={updateChargeName} onBlur={(e) => e.target.value == "" ? setShowUpdateChargeNameError(true) : setShowUpdateChargeNameError(false)} />
                  </>
                    :
                  <>
                  <label for="charge_name">Charge Name: <i className="text-danger">*</i><span className="text-danger">{showChargeNameError ? " Charge Name required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="charge_name" name="charge_name" placeholder="Enter Charge Name" onChange={(e) => setChargeName(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowChargeNameError(true) : setShowChargeNameError(false)} />
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="product">Product: <i className="text-danger">*</i><span className="text-danger">{showUpdateProductError ? " Product required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="product" onChange={(e) => setUpdateChargeProduct(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateProductError(true) : setShowUpdateProductError(false)}>
                    <option value="" selected>Select Product</option>
                    {productList.map(product => 
                      <option value={product.id} selected={updateChargeProduct==product.id?true:false}>{product.product_name}</option>
                    )}
                  </select>
                  </>
                  :
                  <>
                  <label for="charge_type">Type: <i className="text-danger">*</i><span className="text-danger">{showChargeTypeError ? " Type required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="product" onChange={(e) => setProduct(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowProductError(true) : setShowProductError(false)}>
                    <option value="" selected>Select Product</option>
                    {productList.map(product => 
                      <option value={product.id}>{product.product_name}</option>
                    )}
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="charge_type">Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeTypeError ? " Type required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="charge_type" onChange={(e) => setUpdateChargeType(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateChargeTypeError(true) : setShowUpdateChargeTypeError(false)}>
                    <option value="" selected>Select Type</option>
                    <option value="HAZARDOUS" selected={updateChargeType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                    <option value="NON_HAZARDOUS" selected={updateChargeType=="NON_HAZARDOUS"?true:false}>NON HAZARDOUS</option>
                    <option value="MIX_HAZARDOUS" selected={updateChargeType=="MIX_HAZARDOUS"?true:false}>MIX HAZARDOUS</option>
                  </select>
                  </>
                  :
                  <>
                  <select className="form-select form-select-sm" name="charge_type" onChange={(e) => setChargeType(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowChargeTypeError(true) : setShowChargeTypeError(false)}>
                    <option value="" selected>Select Type</option>
                    <option value="HAZARDOUS">HAZARDOUS</option>
                    <option value="NON_HAZARDOUS">NON HAZARDOUS</option>
                    <option value="MIX_HAZARDOUS">MIX HAZARDOUS</option>
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="charge_category">Category: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeCategoryError ? " Category required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="charge_category" onChange={(e) => setUpdateChargeCategory(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateChargeCategoryError(true) : setShowUpdateChargeCategoryError(false)}>
                    <option value="" selected>Select Category</option>
                    <option value="FREIGHT" selected={updateChargeCategory=="FREIGHT"?true:false}>FREIGHT</option>
                    <option value="EXPORT_LOCAL" selected={updateChargeCategory=="EXPORT_LOCAL"?true:false}>EXPORT LOCAL</option>
                    <option value="IMPORT_LOCAL" selected={updateChargeCategory=="IMPORT_LOCAL"?true:false}>IMPORT LOCAL</option>
                    <option value="SURCHARGE" selected={updateChargeCategory=="SURCHARGE"?true:false}>SURCHARGE</option>
                    <option value="DOCUMENTATION" selected={updateChargeCategory=="DOCUMENTATION"?true:false}>DOCUMENTATION</option>
                    <option value="CUSTOM" selected={updateChargeCategory=="CUSTOM"?true:false}>CUSTOM</option>
                    <option value="OTHER" selected={updateChargeCategory=="OTHER"?true:false}>OTHER</option>
                  </select>
                  </>
                  :
                  <>
                  <label for="charge_category">Category: <i className="text-danger">*</i><span className="text-danger">{showChargeCategoryError ? " Category required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="charge_category" onChange={(e) => setChargeCategory(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowChargeCategoryError(true) : setShowChargeCategoryError(false)}>
                    <option value="" selected>Select Category</option>
                    <option value="FREIGHT">FREIGHT</option>
                    <option value="EXPORT_LOCAL">EXPORT LOCAL</option>
                    <option value="IMPORT_LOCAL">IMPORT LOCAL</option>
                    <option value="SURCHARGE">SURCHARGE</option>
                    <option value="DOCUMENTATION">DOCUMENTATION</option>
                    <option value="CUSTOM">CUSTOM</option>
                    <option value="OTHER">OTHER</option>
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="charge_basis">Basis: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeBasisError ? " Basis required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="charge_basis" onChange={(e) => setUpdateChargeBasis(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateChargeBasisError(true) : setShowUpdateChargeBasisError(false)}>
                    <option value="" selected>Select Basis</option>
                    <option value="PER_CONTAINER" selected={updateChargeBasis=="PER_CONTAINER"?true:false}>PER CONTAINER</option>
                    <option value="PER_CBM" selected={updateChargeBasis=="PER_CBM"?true:false}>PERCBM</option>
                    <option value="PER_KG" selected={updateChargeBasis=="PER_KG"?true:false}>PER KG</option>
                    <option value="FLAT" selected={updateChargeBasis=="FLAT"?true:false}>FLAT</option>
                    <option value="PER_SHIPMENT" selected={updateChargeBasis=="PER_SHIPMENT"?true:false}>PER SHIPMENT</option>
                    <option value="PER_BILL" selected={updateChargeBasis=="PER_BILL"?true:false}>PER BILL</option>
                    <option value="BY_WEIGHT_LIMIT" selected={updateChargeBasis=="BY_WEIGHT_LIMIT"?true:false}>BY WEIGHT LIMIT</option>
                  </select>
                  </>
                  :
                  <>
                  <label for="charge_basis">Basis: <i className="text-danger">*</i><span className="text-danger">{showChargeBasisError ? " Basis required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="charge_basis" onChange={(e) => setChargeBasis(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowChargeBasisError(true) : setShowChargeBasisError(false)}>
                    <option value="" selected>Select Basis</option>
                    <option value="PER_CONTAINER">PER CONTAINER</option>
                    <option value="PER_CBM">PERCBM</option>
                    <option value="PER_KG">PER KG</option>
                    <option value="FLAT">FLAT</option>
                    <option value="PER_SHIPMENT">PER SHIPMENT</option>
                    <option value="PER_BILL">PER BILL</option>
                    <option value="BY_WEIGHT_LIMIT">BY WEIGHT LIMIT</option>
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="amount">Amount: <i className="text-danger">*</i><span className="text-danger">{showUpdateAmountError ? " Amount required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="amount" name="amount" placeholder="Enter Amount" onChange={(e) => setUpdateChargeAmount(e.target.value)}
                    value={updateChargeAmount} onBlur={(e) => e.target.value == "" ? setShowUpdateAmountError(true) : setShowUpdateAmountError(false)} />
                  </>
                  :
                  <>
                  <label for="amount">Amount: <i className="text-danger">*</i><span className="text-danger">{showAmountError ? " Amount required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="amount" name="amount" placeholder="Enter Amount" onChange={(e) => setAmount(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowAmountError(true) : setShowAmountError(false)} />
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="amount_type">Amount Type: <i className="text-danger">*</i><span className="text-danger">{showUpdateAmountTypeError ? " Type required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="amount_type" onChange={(e) => setUpdateChargeAmountType(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateAmountTypeError(true) : setShowUpdateAmountTypeError(false)}>
                    <option value="" selected>Select Type</option>
                    <option value="AMOUNT" selected={updateChargeAmountType=="AMOUNT"?true:false}>AMOUNT</option>
                    <option value="PERCENTAGE" selected={updateChargeAmountType=="PERCENTAGE"?true:false}>PERCENTAGE</option>
                  </select>
                  </>
                  :
                  <>
                  <label for="amount_type">Amount Type: <i className="text-danger">*</i><span className="text-danger">{showAmountTypeError ? " Type required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="amount_type" onChange={(e) => setAmountType(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowAmountTypeError(true) : setShowAmountTypeError(false)}>
                    <option value="" selected>Select Type</option>
                    <option value="AMOUNT">AMOUNT</option>
                    <option value="PERCENTAGE">PERCENTAGE</option>
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="expense">Expense: <i className="text-danger">*</i><span className="text-danger">{showUpdateExpenseError ? " Expense required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="expense" name="expense" placeholder="Enter Expense" onChange={(e) => setUpdateChargeExpense(e.target.value)}
                    value={updateChargeExpense} onBlur={(e) => e.target.value == "" ? setShowUpdateExpenseError(true) : setShowUpdateExpenseError(false)} />
                  </>
                  :
                  <>
                  <label for="expense">Expense: <i className="text-danger">*</i><span className="text-danger">{showExpenseError ? " Expense required" : ""}</span></label>
                  <input type="text" class="form-control form-control-sm" id="expense" name="expense" placeholder="Enter Expense" onChange={(e) => setExpense(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowExpenseError(true) : setShowExpenseError(false)} />
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showUpdateChargeCurrencyError ? " Currency required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="currency" onChange={(e) => setUpdateChargeCurrency(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateChargeCurrencyError(true) : setShowUpdateChargeCurrencyError(false)}>
                    <option value="" selected>Select Currency</option>
                    {currencyList.map(currency => 
                      <option value={currency.id} selected={updateChargeCurrency==currency.id?true:false}>{currency.name} ({currency.symbol})</option>
                    )}
                  </select>
                  </>
                  :
                  <>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showChargeCurrencyError ? " Currency required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="currency" onChange={(e) => setChargeCurrency(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowChargeCurrencyError(true) : setShowChargeCurrencyError(false)}>
                    <option value="" selected>Select Currency</option>
                    {currencyList.map(currency => 
                      <option value={currency.id}>{currency.name} ({currency.symbol})</option>
                    )}
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="is_terminal_specific">Is Terminal Specific? </label>
                  <select className="form-select form-select-sm" name="is_terminal_specific" onChange={(e) => setUpdateIsTerminalSpecificCharge(e.target.value)}>
                    <option value="NO" selected={updateIsTerminalSpecificCharge=="NO"?true:false}>NO</option>
                    <option value="YES" selected={updateIsTerminalSpecificCharge=="YES"?true:false}>YES</option>
                  </select>
                  </>
                  :
                  <>
                  <label for="is_terminal_specific">Is Terminal Specific? </label>
                  <select className="form-select form-select-sm" name="is_terminal_specific" onChange={(e) => setIsTerminalSpecificCharge(e.target.value)}>
                    <option value="NO">NO</option>
                    <option value="YES">YES</option>
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="terminal">Terminal: <i className="text-danger">*</i><span className="text-danger">{showUpdateTerminalError ? " Terminal required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="terminal" onChange={(e) => setUpdateChargeTerminal(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowTerminalError(true) : setShowTerminalError(false)}>
                    <option value="" selected>Select Terminal</option>
                    {terminalList.map(terminal => 
                      <option value={terminal.id} selected={updateChargeTerminal==terminal.id?true:false}>{terminal.name}</option>
                    )}
                  </select>
                  </>
                  :
                  <>
                  <label for="terminal">Terminal: <i className="text-danger">*</i><span className="text-danger">{showTerminalError ? " Terminal required" : ""}</span></label>
                  <select className="form-select form-select-sm" name="terminal" onChange={(e) => setTerminal(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowTerminalError(true) : setShowTerminalError(false)}>
                    <option value="" selected>Select Terminal</option>
                    {terminalList.map(terminal => 
                      <option value={terminal.id}>{terminal.name}</option>
                    )}
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="payable_by">Payable By </label>
                  <select className="form-select form-select-sm" name="payable_by" onChange={(e) => setUpdateChargePayableBy(e.target.value)}>
                    <option value="SHIPPER" selected={updateChargePayableBy=="SHIPPER"?true:false}>SHIPPER</option>
                    <option value="CONSIGNEE" selected={updateChargePayableBy=="CONSIGNEE"?true:false}>CONSIGNEE</option>
                    <option value="AGENT" selected={updateChargePayableBy=="AGENT"?true:false}>AGENT</option>
                    <option value="LINE" selected={updateChargePayableBy=="LINE"?true:false}>LINE</option>
                    <option value="CUSTOMER" selected={updateChargePayableBy=="CUSTOMER"?true:false}>CUSTOMER</option>
                    <option value="THIRD_PARTY" selected={updateChargePayableBy=="THIRD_PARTY"?true:false}>THIRD PARTY</option>
                  </select>
                  </>
                  :
                  <>
                  <label for="payable_by">Payable By </label>
                  <select className="form-select form-select-sm" name="payable_by" onChange={(e) => setPayableBy(e.target.value)}>
                    <option value="SHIPPER">SHIPPER</option>
                    <option value="CONSIGNEE">CONSIGNEE</option>
                    <option value="AGENT">AGENT</option>
                    <option value="LINE">LINE</option>
                    <option value="CUSTOMER">CUSTOMER</option>
                    <option value="THIRD_PARTY">THIRD PARTY</option>
                  </select>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="valid_from">Valid From: <i className="text-danger">*</i><span className="text-danger">{showUpdateValidFromError ? " Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="valid_from" name="valid_from" onChange={(e) => setUpdateChargeValidFrom(e.target.value)}
                    value={chargeValidFrom} onBlur={(e) => e.target.value == "" ? setShowUpdateValidFromError(true) : setShowUpdateValidFromError(false)} />
                  </>
                  :
                  <>
                  <label for="valid_from">Valid From: <i className="text-danger">*</i><span className="text-danger">{showValidFromError ? " Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="valid_from" name="valid_from" onChange={(e) => setChargeValidFrom(e.target.value)}
                   onBlur={(e) => e.target.value == "" ? setShowValidFromError(true) : setShowValidFromError(false)} />
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="valid_to">Valid To: <i className="text-danger">*</i><span className="text-danger">{showUpdateValidToError ? " Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="valid_to" name="valid_to" onChange={(e) => setUpdateChargeValidTo(e.target.value)}
                    value={chargeValidTo} onBlur={(e) => e.target.value == "" ? setShowUpdateValidToError(true) : setShowUpdateValidToError(false)} />
                  </>
                  :
                  <>
                  <label for="valid_to">Valid To: <i className="text-danger">*</i><span className="text-danger">{showValidToError ? " Date required" : ""}</span></label>
                  <input type="date" class="form-control form-control-sm" id="valid_to" name="valid_to" onChange={(e) => setChargeValidTo(e.target.value)}
                   onBlur={(e) => e.target.value == "" ? setShowValidToError(true) : setShowValidToError(false)} />
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-2":"col-md-2"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="remarks">Remarks: </label>
                  <input type="date" class="form-control form-control-sm" id="remarks" name="remarks" onChange={(e) => setUpdateChargeRemarks(e.target.value)}
                    value={chargeRemarks}/>
                  </>
                  :
                  <>
                  <label for="remarks">Remarks: </label>
                  <input type="date" class="form-control form-control-sm" id="remarks" name="remarks" onChange={(e) => setChargeRemarks(e.target.value)} />
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-1":"col-md-1"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="is_mandatory">Is Mandatory? </label><br></br>
                  <input type="checkbox" class="form-checkbox" id="is_mandatory" name="is_mandatory" value={updateIsMandatoryCharge} onChange={(e) => setUpdateIsMandatoryCharge(e.target.checked)}/>
                  </>
                  :
                  <>
                  <label for="is_mandatory">Is Mandatory? </label><br></br>
                  <input type="checkbox" class="form-checkbox" id="is_mandatory" name="is_mandatory" onChange={(e) => setIsMandatory(e.target.checked)}/>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-1":"col-md-1"} text-left mb-4`}>
                  {tariffChargeForUpdate?
                  <>
                  <label for="is_active">Is Active? </label><br></br>
                  <input type="checkbox" class="form-checkbox" id="is_active" name="is_active" value={updateChargeIsActive} onChange={(e) => setUpdateChargeIsActive(e.target.checked)}/>
                  </>
                  :
                  <>
                  <label for="is_active">Is Active? </label><br></br>
                  <input type="checkbox" class="form-checkbox" id="is_active" name="is_active" onChange={(e) => setChargeIsActive(e.target.checked)}/>
                  </>
                  }
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-1":"col-md-1"} text-left mb-4`}>
                  <Button className="btn btn-inox-green border-0 w-100 mt-2" onClick={(e) => addTariffCharge(e)}>
                    {showAddChargeLoader?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    :
                    <>
                      <i className="fa fa-plus"></i> <span className="mx-2">Add</span>
                    </>
                  }
                  </Button>
                </div>
              </div>
            </form>

            <DataTable
              columns={tariffchargecolumns}
              data={tariffChargeList}
              progressPending={chargeDataPending}
              progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
              noDataComponent={<p className="text-center my-5">No Data Found</p>}
              pagination
              highlightOnHover
              customStyles={tariffChargeTableCustomStyles}
              dense
            />
          </div>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div class={canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-100 show":
        !canvasFullScreen && showAddCanvas?"offcanvas offcanvas-bottom h-60 show":"offcanvas offcanvas-bottom h-60"} 
        data-bs-scroll="true" tabindex="-1" id="addSection" aria-labelledby="offcanvasBottomLabel">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Add New Record</h4>
            </div>
            <div className="col-6">
              <button type="button" class="btn btn-danger btn-sm float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close"
              onClick={() => [setShowAddCanvas(false)]}>
                  <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen?
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Half Screen" onClick={() => [setCanvasFullScreen(false), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-minimize text-white"></i>
                </button>
                :
                <button type="button" class="btn btn-inox-green btn-sm mx-2 float-right" title="Full Screen" onClick={() => [setCanvasFullScreen(true), setShowAddCanvas(true)]}>
                    <i className="fa fa-window-maximize text-white"></i>
                </button>
              }
            </div>
          </div>
        </div>

        <div class="offcanvas-body" style={{ paddingLeft: 20, paddingRight: 40 }}>
            <form ref={addform} onSubmit={(e) => addNewTariff(e)}>
              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="agent">Agent: <i className="text-danger">*</i><span className="text-danger">{showCurrentAgentError?"Agent required":""}</span></label>
                  <select className="form-select form-select-sm" name="agent" onChange={(e) => setCurrentAgent(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowCurrentAgentError(true):setShowCurrentAgentError(false)}>
                    <option value="" selected>Select Agent</option>
                    {agentList.map(agent => 
                      <option value={agent.id} selected={currentAgent==agent.id?true:false}>{agent.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="vendor">Vendor: </label>
                  <select className="form-select form-select-sm" name="vendor" onChange={(e) => setCurrentVendor(e.target.value)}>
                    <option value="" selected>Select Vendor</option>
                    {vendorList.map(vendor => 
                      <option value={vendor.id} selected={currentVendor==vendor.id?true:false}>{vendor.name}</option>
                    )}
                  </select>
                </div>

                {/* <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="currency">Currency: <i className="text-danger">*</i><span className="text-danger">{showCurrentCurrencyError?"Currency required":""}</span></label>
                  <select className="form-select form-select-sm" name="currency" onChange={(e) => setCurrentCurrency(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowCurrentCurrencyError(true):setShowCurrentCurrencyError(false)}>
                    <option value="" selected>Select Currency</option>
                    {currencyList.map(currency => 
                      <option value={currency.id} selected={currentCurrency==currency.id?true:false}>{currency.name}</option>
                    )}
                  </select>
                </div> */}

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="poa">POA: <i className="text-danger">*</i><span className="text-danger">{showCurrentPoaError?"Poa required":""}</span></label>
                  <select className="form-select form-select-sm" name="poa" onChange={(e) => setCurrentPoa(e.target.value)}
                  onBlur={(e) => [e.target.value==""?setShowCurrentPoaError(true):setShowCurrentPoaError(false), getPoaTerminal(e.target.value)]}>
                    <option value="" selected>Select Port</option>
                    {portList.map(poa => 
                      <option value={poa.id} selected={currentPoa==poa.id?true:false}>{poa.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="poa_terminal">POA Terminal: <i className="text-danger">*</i><span className="text-danger">{showCurrentPoaTerminalError?"PoaTerminal required":""}</span></label>
                  <select className="form-select form-select-sm" name="poa_terminal" onChange={(e) => setCurrentPoaTerminal(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowCurrentPoaTerminalError(true):setShowCurrentPoaTerminalError(false)}>
                    <option value="" selected>Select Terminal</option>
                    {poaTerminalList.map(poa => 
                      <option value={poa.id} selected={currentPoaTerminal==poa.id?true:false}>{poa.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="pol">POL: </label>
                  <select className="form-select form-select-sm" name="pol" onChange={(e) => setCurrentPol(e.target.value)}
                  onBlur={(e) => getPolTerminal(e.target.value)}>
                    <option value="" selected>Select Port</option>
                    {portList.map(pol => 
                      <option value={pol.id} selected={currentPol==pol.id?true:false}>{pol.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="pol_terminal">POL Terminal: </label>
                  <select className="form-select form-select-sm" name="pol_terminal" onChange={(e) => setCurrentPolTerminal(e.target.value)}>
                    <option value="" selected>Select Terminal</option>
                    {polTerminalList.map(pol => 
                      <option value={pol.id} selected={currentPolTerminal==pol.id?true:false}>{pol.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="pod">POD: </label>
                  <select className="form-select form-select-sm" name="pod" onChange={(e) => setCurrentPod(e.target.value)}
                  onBlur={(e) => getPodTerminal(e.target.value)}>
                    <option value="" selected>Select Port</option>
                    {portList.map(pod => 
                      <option value={pod.id} selected={currentPod==pod.id?true:false}>{pod.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="pod_terminal">POD Terminal: </label>
                  <select className="form-select form-select-sm" name="pod_terminal" onChange={(e) => setCurrentPodTerminal(e.target.value)}>
                    <option value="" selected>Select Terminal</option>
                    {podTerminalList.map(pod => 
                      <option value={pod.id} selected={currentPodTerminal==pod.id?true:false}>{pod.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="fd">FD: </label>
                  <select className="form-select form-select-sm" name="fd" onChange={(e) => setCurrentFd(e.target.value)}
                  onBlur={(e) => getFdTerminal(e.target.value)}>
                    <option value="" selected>Select Port</option>
                    {portList.map(fd => 
                      <option value={fd.id} selected={currentFd==fd.id?true:false}>{fd.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="fd_terminal">FD Terminal: </label>
                  <select className="form-select form-select-sm" name="fd_terminal" onChange={(e) => setCurrentFdTerminal(e.target.value)}>
                    <option value="" selected>Select Terminal</option>
                    {fdTerminalList.map(fd => 
                      <option value={fd.id} selected={currentFdTerminal==fd.id?true:false}>{fd.name}</option>
                    )}
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="event_type">Event Type: <i className="text-danger">*</i><span className="text-danger">{showCurrentEventTypeError?"Event Type required":""}</span></label>
                  <select className="form-select form-select-sm" name="event_type" onChange={(e) => setCurrentEventType(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowCurrentEventTypeError(true):setShowCurrentEventTypeError(false)}>
                    <option value="" selected>Select Type</option>
                      <option value="EXPORT_PAYABLE" selected={currentEventType=="EXPORT_PAYABLE"?true:false}>EXPORT PAYABLE</option>
                      <option value="EXPORT_RECEIVABLE" selected={currentEventType=="EXPORT_RECEIVABLE"?true:false}>EXPORT RECEIVABLE</option>
                      <option value="IMPORT_PAYABLE" selected={currentEventType=="IMPORT_PAYABLE"?true:false}>IMPORT PAYABLE</option>
                      <option value="IMPORT_RECEIVABLE" selected={currentEventType=="IMPORT_RECEIVABLE"?true:false}>IMPORT RECEIVABLE</option>
                      <option value="RAIL_TO_SEA_TSP_EXPORT_PAYABLE" selected={currentEventType=="RAIL_TO_SEA_TSP_EXPORT_PAYABLE"?true:false}>RAIL TO SEA TSP EXPORT PAYABLE</option>
                      <option value="RAIL_TO_SEA_TSP_IMPORT_PAYABLE" selected={currentEventType=="RAIL_TO_SEA_TSP_IMPORT_PAYABLE"?true:false}>RAIL TO SEA TSP IMPORT PAYABLE</option>
                      <option value="SEA_TO_RAIL_TSP_EXPORT_PAYABLE" selected={currentEventType=="SEA_TO_RAIL_TSP_EXPORT_PAYABLE"?true:false}>SEA TO RAIL TSP EXPORT PAYABLE</option>
                      <option value="SEA_TO_RAIL_TSP_IMPORT_PAYABLE" selected={currentEventType=="SEA_TO_RAIL_TSP_IMPORT_PAYABLE"?true:false}>SEA TO RAIL TSP IMPORT PAYABLE</option>
                      <option value="SEA_TO_SEA_TSP_EXPORT_PAYABLE" selected={currentEventType=="SEA_TO_SEA_TSP_EXPORT_PAYABLE"?true:false}>SEA TO SEA TSP EXPORT PAYABLE</option>
                      <option value="SEA_TO_SEA_TSP_IMPORT_PAYABLE" selected={currentEventType=="SEA_TO_SEA_TSP_IMPORT_PAYABLE"?true:false}>SEA TO SEA TSP IMPORT PAYABLE</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="event_sub_type">Event Sub-Type: <i className="text-danger">*</i><span className="text-danger">{showCurrentEventSubTypeError?"Event Sub Type required":""}</span></label>
                  <select className="form-select form-select-sm" name="event_sub_type" onChange={(e) => setCurrentEventSubType(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowCurrentEventSubTypeError(true):setShowCurrentEventSubTypeError(false)}>
                    <option value="" selected>Select Sub Type</option>
                      <option value="ALL_CONTAINERS_PICKED" selected={currentEventSubType=="ALL_CONTAINERS_PICKED"?true:false}>ALL CONTAINERS PICKED</option>
                      <option value="BL_MARKED_EXPRESS" selected={currentEventSubType=="BL_MARKED_EXPRESS"?true:false}>BL MARKED EXPRESS</option>
                      <option value="BL_MARKED_SEAWAY" selected={currentEventSubType=="BL_MARKED_SEAWAY"?true:false}>BL MARKED SEAWAY</option>
                      <option value="BL_SURRENDERED" selected={currentEventSubType=="BL_SURRENDERED"?true:false}>BL SURRENDERED</option>
                      <option value="CERTIFICATE_ISSUED" selected={currentEventSubType=="CERTIFICATE_ISSUED"?true:false}>CERTIFICATE ISSUED</option>
                      <option value="REACHED_FD" selected={currentEventSubType=="REACHED_FD"?true:false}>REACHED FD</option>
                      <option value="REACHED_TSP" selected={currentEventSubType=="REACHED_TSP"?true:false}>REACHED TSP</option>
                      <option value="SHIPPED_ON_BOARD" selected={currentEventSubType=="SHIPPED_ON_BOARD"?true:false}>SHIPPED ON BOARD</option>
                      <option value="SOB_FROM_TSP" selected={currentEventSubType=="SOB_FROM_TSP"?true:false}>SOB FROM TSP</option>
                  </select>
                </div>

                <div class={`form-group ${canvasFullScreen?"col-md-3":"col-md-3"} text-left mb-4`}>
                  <label for="cargo_type">Cargo Type: <i className="text-danger">*</i><span className="text-danger">{showCurrentCargoTypeError?"Cargo Type required":""}</span></label>
                  <select className="form-select form-select-sm" name="cargo_type" onChange={(e) => setCurrentCargoType(e.target.value)}
                  onBlur={(e) => e.target.value==""?setShowCurrentCargoTypeError(true):setShowCurrentCargoTypeError(false)}>
                    <option value="" selected>Select Type</option>
                      <option value="HAZARDOUS" selected={currentCargoType=="HAZARDOUS"?true:false}>HAZARDOUS</option>
                      <option value="NON_HAZARDOUS" selected={currentCargoType=="NON_HAZARDOUS"?true:false}>NON_HAZARDOUS</option>
                      <option value="MIX_HAZARDOUS" selected={currentCargoType=="MIX_HAZARDOUS"?true:false}>MIX_HAZARDOUS</option>
                      <option value="EMPTY" selected={currentCargoType=="EMPTY"?true:false}>EMPTY</option>
                  </select>
                </div>
              </div>

              <div className="row">
                <div class={`form-group ${canvasFullScreen?"col-md-12 mt-3":"col-md-12 mt-3"}`}>
                  <Button className="btn btn-inox-green border-0 canvas-button" onClick={(e) => addNewTariff(e)}>
                  {showAddLoader?
                      <Spinner className="mx-4" as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    :
                    <>
                      <i className="fa fa-plus"></i> <span className="mx-2">Add</span>
                    </>
                  }
                  </Button>
                </div>
              </div>
            </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default ManageTariff;
